<template>
  <CHeader with-subheader style="background-color: #2F3841 !important;">
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img src="/main_logo.png" style="width: 200px; height: 30px;" alt="Logo">
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-12">
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <span style="height: 20px;"><CIcon :height="20" name="cil-cog" /></span>
      </CHeaderNavLink>
    </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Administrador</strong>
      </CDropdownHeader>
      <CDropdownItem @click="logout">
        <CIcon name="cil-lock-locked" /> Cerrar Sesión
      </CDropdownItem>
    </CDropdown>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import router from '../router/index'

export default {
  name: 'TheHeader',
  components: {
  },
  data () {
    return { 
    }
  },
  mounted: async function() {
  },
  methods: {
    logout: function(){
      localStorage.removeItem("token");
      localStorage.removeItem("domain");

      router.push("Login");
    },
  }
}
</script>
